import React, { useEffect, useState } from "react";
import { Card, Col, Row, Select } from "antd";
import TimeZonesList from "../../../../utils/timezones.json";

const TimeZones = ({ widget, handleWidgetChange }) => {
  const [timezone, setTimezone] = useState("");
  const [selectedTimezone, setSelectedTimezone] = useState("");
  const handleSave = () => {
    handleWidgetChange({ timezone: selectedTimezone, id: widget.id });
  };

  useEffect(() => {
    let currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (widget.timezone) currentTimezone = widget.timezone;
    const foundTimezone = TimeZonesList.find((x) =>
      x.utc.includes(currentTimezone)
    );
    setTimezone(foundTimezone.value);
    setSelectedTimezone(currentTimezone);
  }, [widget.id, widget.hoursRestriction]);

  const handleTimezoneChange = (value) => {
    const foundTimezone = TimeZonesList.find((x) => x.value === value);
    setTimezone(value);
    setSelectedTimezone(foundTimezone.utc[0]);
  };

  return (
    <Card className="setting_wrapper">
      <Row className="center_items setting_label">
        <Col span={12}>
          <h4 className="p-color">Timezone</h4>
        </Col>
        <Col span={12} className="action">
          <div onClick={handleSave} className="action_btn ml-2">
            <i className="fa-regular fa-floppy-disk "></i>
            <span>Save</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Select
            className="select_feld"
            placeholder="Select option"
            allowClear={false}
            optionFilterProp="children"
            showSearch
            value={timezone}
            onChange={handleTimezoneChange}
          >
            {TimeZonesList.map((timezone, index) => (
              <Select.Option key={index} value={timezone.value}>
                {timezone.text}
              </Select.Option>
            ))}
          </Select>
        </Col>
      </Row>
    </Card>
  );
};

export default React.memo(TimeZones);
